export const trading = {
    kpsj: "Açılış zamanı",
    jlks: "Başlamasına kalan süre",
    t: "gün",
    s: "saat",
    f: "dakika",
    m: "saniye",

    zgj: "En yüksek fiyat:",
    zdj: "En düşük fiyat:",
    gflj: "Resmi bağlantı",
    gw: "Resmi site",
    qkllq: "Blok tarayıcı",
    scfxsj: "İlk ihraç zamanı",
    fxzl: "Toplam arz",
    ltzl: "Dolaşımdaki arz",
    jy: "İşlem",
    sj: "Piyasa fiyatı",
    tbxx: "Grafik bilgisi",
    bzgk: "Para birimi genel bakış",
    jcb: "Temel sürüm",
    ddb: "Sipariş tablosu",
    zxcj: "Son işlem",

    reload: "Yenile",
    socketError: "Ağ hatası, lütfen",
    noData: "Henüz veri yok",
    entrustorder: "Sipariş defteri",
    prices: "Fiyat",
    quantity: "Miktar",
    grandtotal: "Kümülatif",
    transamount: "İşlem hacmi",
    time: "Zaman",
    available: "Kullanılabilir",
    limitorder: "Limit emri",
    plancommission: "Planlı emir",
    currentcommission: "Mevcut emir",
    historycommission: "Geçmiş emirler",
    completecommission: "Tamamlanan emirler",
    funds: "Fonlar",
    hidetrading: "Diğer işlem çiftlerini gizle",
    morecurrentcommission: "Daha fazla mevcut emir",
    morehistorycommission: "Daha fazla geçmiş emir",
    moredocommission: "Daha fazla tamamlanan emir",
    realtimetrans: "Gerçek zamanlı işlemler",
    myassets: "Varlıklarım",
    detail: "Detay",
    buyin: "Al",
    sellout: "Sat",
    login: "Giriş yap",
    transfer: "Transfer",
    recharge: "Para yatırma",
    withdrawal: "Para çekme",
    quickpurchase: "Fiat hızlı para satın alma",
    default: "Varsayılan",
    ordertime: "Emir zamanı",
    tradingpair: "İşlem çifti",
    direction: "Yön",
    types: "Tür",
    commissionprice: "Emir fiyatı",
    commissionnumber: "Emir miktarı",
    dealprice: "Ortalama işlem fiyatı",
    dealnumber: "İşlem miktarı",
    triggerprice: "Tetik fiyatı",
    cancelall: "Tümünü iptal et",
    averageprice: "Ortalama fiyat",
    totalsum: "Toplam",
    fixedprice: "Sabit fiyat",
    marketprice: "Piyasa fiyatı",
    codeExpired: "QR kodun süresi doldu",
    clickRefresh: "Yenilemek için tıklayın",
    QRsuccessfully: "QR kod başarıyla tarandı",
    loginInApp: "Lütfen girişi uygulamada onaylayın",
    backtoQR: "QR kodu girişine dön",
    loginSuccess: "Başarıyla giriş yaptınız, BiKing'e hoş geldiniz!",
    loadingText: "Yükleniyor...",
    searchPlaceholder: "Arama",
    all: "Tümü",
    currency: "Para birimi",
    price: "Son fiyat",
    market: "Kazananlar",
    increase: "Artış",
    highestPrice: "En yüksek",
    minimumPrice: "En düşük",
    turnover: "İşlem hacmi",
    jydlb: "İşlem çifti listesi",
    bzjs: "Para birimi tanıtımı",
    currencyTransaction: "Parite işlemi",
    leveragedTransaction: "Kaldıraçlı işlem",
    warning:
        "Risk uyarısı: Bitcoin Cash fork büyük belirsizlik taşır. Fork vadeli tokenleriyle işlem yapmak veya yatırım yapmak büyük risk içerir. Bir zincir madenciler tarafından desteklenmezse sürdürülemez hale gelebilir ve ilgili tokenler değerini kaybedebilir. BiKing fork vadeli tokenlerinin değeri hakkında herhangi bir taahhütte bulunmaz!",
    zb: "Gösterge",
    date: "Zaman",
    UpAnddown: "Değişim",
    amplitude: "Dalgalanma",
    0: "Anlık",
    1: "1 dakika",
    5: "5 dakika",
    15: "15 dakika",
    30: "30 dakika",
    60: "1 saat",
    240: "4 saat",
    3600: "1 gün",
    10800: "1 hafta",
    dates: "Periyot:",
    password: "İşlem şifresi",
    errorPassword: "Lütfen doğru işlem şifresini girin",
    worningPassword: "Lütfen işlem şifresini girin",
    cancel: "İptal",
    sure: "Onayla",
    canBuy: "Alınabilir",
    canCell: "Satılabilir",
    withdraw: "Para çekme",
    otc: "OTC, fiat hızlı giriş ve çekim",
    enterPrice: "Lütfen fiyat girin",
    sellingPrice: "Satış fiyatı",
    purchasePrice: "Alış fiyatı",
    salesVolume: "Satış hacmi",
    buyingVolume: "Alış hacmi",
    volume: "İşlem hacmi",
    serviceCharge: "Komisyon",
    vip: "VIP'e yüksel, komisyonda indirim",
    or: "veya",
    register: "Kayıt ol",
    totalPrice: "İşlem hacmi şundan büyük olamaz",
    amountTip: "Lütfen doğru miktarı girin",
    amountTipError: "Miktar şundan büyük olamaz",
    limitTrading: "Limit işlemi",
    priceReminder: "Fiyat hatırlatıcısı",
    SMSReminder: "SMS hatırlatıcı",
    loginAccount: "Giriş hesabı",
    phone: "Telefon",
    phoneNum: "Lütfen telefon numarası girin",
    phoneTips: "Lütfen doğru telefon numarası girin",
    email: "E-posta",
    emailNum: "Lütfen e-posta girin",
    emailTips: "Lütfen doğru e-posta girin",
    aears: "Lütfen alan kodunu seçin",
    passwordError: "Lütfen doğru şifreyi girin",
    passwordTips: "Lütfen şifre girin",
    forgetPassword: "Şifremi unuttum",
    noAccount: "Hesabınız yok mu?",
    goRegister: "Hemen kayıt ol",
    appsys: "APP QR kodu ile güvenli giriş",
    xzapp: "En son APP'i indirin",
    mmdl: "Şifre ile giriş",
    smdl: "QR kodu ile giriş",
    google: "Google Authenticator",
    nybd: "Zaten bağlandınız",
    zqyzm: "Lütfen doğru doğrulama kodunu girin",
    fsyzm: "Doğrulama kodu gönder",
    flv: "Oran",
    jz: "Net değer",
    jzdesc1:
        "Long net değeri = Son ayarlama noktasındaki net değer * [1+3*(Spot son işlem fiyatı - Spot son ayarlama noktası fiyatı)/Spot son ayarlama noktası fiyatı * 100%];",
    jzdesc2:
        "Short net değeri = Son ayarlama noktasındaki net değer * [1-3*(Spot son işlem fiyatı - Spot son ayarlama noktası fiyatı)/Spot son ayarlama noktası fiyatı * 100%];",
    sbd: "3X Long",
    sbs: "3X Short",
    flvjs:
        "ETF fon oranı, platformun fon kombinasyonu tarafından oluşturulan fon oranını ödemek için kaldıraç başına günlük yönetim ücretidir. Yönetim ücreti net değer değişimlerine yansır ve sadece Singapur saati ile 00:00'da alınır. Ürün bu saatte tutulmazsa ücret oluşmaz.",
    mzsm: "Feragatname",
    ido: "Okudum ve kabul ediyorum",
    exemption1: "Sayın müşteri, merhaba!",
    exemption2:
        "BiKing platformunda (BiKing.ai) sunulan kaldıraçlı ETF ürünlerini ve ilgili hizmetleri kullandığınız için teşekkür ederiz. Lütfen ETF ürün açıklamasını ve aşağıdaki risk uyarılarını dikkatlice okuyunuz. Okuduktan sonra ETF ürünlerini kullanmaya devam etmeniz, ETF ürünlerinin risklerini tamamen anladığınızı ve kabul ettiğinizi, ETF ürünlerinin kullanımından kaynaklanabilecek kayıpları üstlenebileceğinizi ve bu feragatnamenin tamamını kabul ettiğinizi gösterir. ETF Ürün Açıklamasını okuyun:",
    exemption3: "《Kaldıraçlı ETF Ürünleri SSS》",
    exemption4: "Risk uyarısı:",
    exemption5:
        "1. Satın alma/satış fiyatınız net varlık değerinden büyük sapmalar göstermemelidir, aksi takdirde karşılık gelen kayıplar yaşayabilirsiniz.",
    exemption6: "2. Yön tahmini yanlışsa, aşırı piyasa koşullarında fiyatın sıfıra yaklaşma riski vardır.",
    exemption7:
        "BiKing platformu, yukarıdaki risklerden kaynaklanan kayıplar veya sorumlulukların tamamen size ait olduğunu ve BiKing platformunun bu konuda herhangi bir sorumluluk kabul etmediğini size hatırlatır. Bu feragatname, BiKing platformundaki diğer sözleşmeler, beyanlar, kurallar vb. ile birlikte, BiKing platformu ile hizmetleri ve ürünleriyle ilgili olarak yapılan tüm anlaşmaları oluşturur.",
    bzjs1: "1. '3L', temel işlem çifti fiyatının %1 yükselmesi durumunda ürünün net değerinin %3 yükseldiğini gösterir",
    bzjs2: "2. '3S', temel işlem çifti fiyatının %1 düşmesi durumunda ürünün net değerinin %3 yükseldiğini gösterir",
    bzjs3: "3. Net değer normalde her gün 00:00'da ayarlanır, aşırı piyasa koşullarında seans içinde ayarlanabilir",
    bzjs4: "4. Her kaldıraç katı için günlük yönetim ücreti alınacaktır",
    bzjs5:
        "5. İşlem yapmadan önce lütfen net değeri kontrol edin. Bu ürün aşırı piyasa koşullarında fiyatın sıfıra yaklaşma ve net değerden önemli ölçüde sapma riski taşır, yatırımcılar lütfen risk kontrolü yapsın",
    gdjk: "Daha fazla detay için duyuruları kontrol edin",
    firstTrading: "İlk işlemden önce lütfen işlem şifresini ayarlayın",
    status: "Durum",
    status1: "Eşleşmeyi bekliyor",
    status2: "İşlenmedi",
    status3: "Kullanıcı iptali",
    status4: "Kısmen işlendi",
    status5: "Tamamen işlendi",
    status6: "Geçersiz",
    allCancel: "Tüm emirleri toplu iptal et",
    canceld: "İptal",
    cancelsuccess: "Tüm emirler başarıyla iptal edildi, [*] emir iptal edildi",
    VIP1: "Seviyeniz VIP",
    VIP2: "Daha düşük işlem komisyonları, daha üstün işlem deneyimi",
    VIP3: "Taker (emir dolduran):",
    VIP4: "Maker (emir veren):",
    buyAmount: "Alım miktarı şundan yüksek olamaz",
    sellAmount: "Satış miktarı şundan yüksek olamaz",
    buyAmountMin: "Alım bakiyeniz yetersiz",
    sellAmountMin: "Satış bakiyeniz yetersiz",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/trading1/tr.js